module.exports = __webpack_public_path__ + "static/flags/TL-afeaa3ae23dbbe1a8585d7ad67a1e10d.gif";